import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { customStyle } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as actions from '../../../action';
import * as c from '../../../constant';

const years = _.range(1970, +moment().format('YYYY') + 1).sort((a, b) => b - a);

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

function GeneralDescription({
  formData,
  setFormData,
  setTab,
  validateForm,
  createRichTextEditor,
  getAppointedPersons,
  appointedPersonsList,
}) {
  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  const appointedPersonsOptions = appointedPersonsList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  useEffect(() => {
    getAppointedPersons();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <>
      <div className="row">
        <div className="col-12 py-0 mb-2">
          <h3 className="m-0 text-color font-weight-bold">
            General Description - Effectivity of Assessment / Reassessment
          </h3>
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="effectivity_of_assessment_reassessment_yr"
            className="form-label mb-0"
          >
            Effectivity of Assessment Year &nbsp;{' '}
            {validateForm.renderMessage(
              'effectivity_of_assessment_reassessment_yr'
            )}
          </label>
          <Select
            options={yearOptions}
            styles={customStyle}
            placeholder="Select Year"
            value={yearOptions.find(
              (item) =>
                item.value ===
                _.get(formData, 'effectivity_of_assessment_reassessment_yr')
            )}
            onChange={handleSelected(
              'effectivity_of_assessment_reassessment_yr'
            )}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="effectivity_of_assessment_reassessment_qtr"
            className="form-label mb-0"
          >
            Effectivity of Assessment Quarter: &nbsp;{' '}
            {validateForm.renderMessage(
              'effectivity_of_assessment_reassessment_qtr'
            )}
          </label>
          <Select
            styles={customStyle}
            placeholder="Select Quarter"
            value={
              quarterList.filter(
                (item) =>
                  `${item.value}` ===
                  _.get(formData, 'effectivity_of_assessment_reassessment_qtr')
              )[0]
            }
            options={quarterList}
            onChange={handleSelected(
              'effectivity_of_assessment_reassessment_qtr'
            )}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="appraised_assessed_by_id" className="form-label mb-0">
            Appraised/Assessed By &nbsp;{' '}
            {validateForm.renderMessage('appraised_assessed_by_id')}
          </label>
          <Select
            options={appointedPersonsOptions}
            placeholder="-Select-"
            value={
              appointedPersonsOptions.filter(
                (item) =>
                  +_.get(formData, 'appraised_assessed_by_id') ===
                  +_.get(item, 'id')
              ) || ''
            }
            onChange={handleSelected('appraised_assessed_by_id')}
          />
        </div>
        <div className="form-group col-6">
          <label htmlFor="appraised_assessed_at" className="form-label mb-0">
            Appraised/Assessed At: &nbsp;{' '}
            {validateForm.renderMessage('appraised_assessed_at')}
          </label>
          <DateInputPicker
            withTime
            className="full-input"
            onChange={handleOnChange('appraised_assessed_at')}
            value={_.get(formData, 'appraised_assessed_at') || ''}
            maxDate={new Date()}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="recommending_by_id" className="form-label mb-0">
            Recommended By &nbsp;{' '}
            {validateForm.renderMessage('recommending_by_id')}
          </label>
          <Select
            options={appointedPersonsOptions}
            placeholder="-Select-"
            value={
              appointedPersonsOptions.filter(
                (item) =>
                  +_.get(formData, 'recommending_by_id') === +_.get(item, 'id')
              ) || ''
            }
            onChange={handleSelected('recommending_by_id')}
          />
        </div>
        <div className="form-group col-6">
          <label htmlFor="last_name" className="form-label mb-0">
            Recommended At: &nbsp;{' '}
            {validateForm.renderMessage('recommending_at')}
          </label>
          <DateInputPicker
            withTime
            className="full-input"
            onChange={handleOnChange('recommending_at')}
            value={_.get(formData, 'recommending_at') || ''}
            maxDate={new Date()}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Approved By &nbsp; {validateForm.renderMessage('approved_by_id')}
          </label>
          <Select
            options={appointedPersonsOptions}
            placeholder="-Select-"
            value={
              appointedPersonsOptions.filter(
                (item) =>
                  +_.get(formData, 'approved_by_id') === +_.get(item, 'id')
              ) || ''
            }
            onChange={handleSelected('approved_by_id')}
          />
        </div>
        <div className="form-group col-6">
          <label htmlFor="last_name" className="form-label mb-0">
            Approved At: &nbsp; {validateForm.renderMessage('approved_at')}
          </label>
          <DateInputPicker
            withTime
            className="full-input"
            onChange={handleOnChange('approved_at')}
            value={_.get(formData, 'approved_at') || ''}
            maxDate={new Date()}
          />
        </div>
        <div className="form-group col-6">
          <label className="form-label">
            Registered: &nbsp; {validateForm.renderMessage('registered')}
          </label>
          <DateInputPicker
            withTime
            className="full-input"
            onChange={handleOnChange('registered')}
            value={_.get(formData, 'registered') || ''}
            maxDate={new Date()}
          />
        </div>
        <div className="col-12 form-group">
          {createRichTextEditor(
            { key: 'memoranda', label: 'Memoranda:' },
            { minLength: 3, required: true }
          )}
        </div>
      </div>
      <hr className="below-hr" style={{ marginTop: 55 }} />
      <div className="py-1">
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setTab(2)}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            disabled={!validateForm.response.is_passed}
          >
            Proceed
          </button>
        </div>
      </div>
    </>
  );
}

GeneralDescription.defaultProps = {};

GeneralDescription.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  setTab: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  getAppointedPersons: PropTypes.instanceOf(Function).isRequired,
  appointedPersonsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  appointedPersonsList: _.get(api, `${c.GET_APPOINTED_PERSONS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(GeneralDescription);
